import { Component, computed, effect, inject, input, viewChildren } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DeviceConnectionStatusWidgetComponent, DeviceStatusBadgeComponent } from '@devices';
import { SpaceLocationComponent, SpaceType } from '@locations';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { WidgetConnectedDevices } from '../../../models';
import { DashboardStore } from '../../../stores';

@Component({
  host: {
    '(scroll)': 'hideTooltips()',
    class: 'flex flex-col overflow-y-auto',
  },
  imports: [
    DeviceConnectionStatusWidgetComponent,
    DeviceStatusBadgeComponent,
    NgxSkeletonLoaderModule,
    RouterLink,
    SpaceLocationComponent,
  ],
  selector: 'avs-connected-devices',
  styleUrl: './connected-devices.component.scss',
  templateUrl: './connected-devices.component.html',
})
export class ConnectedDevicesComponent {
  config = input.required<WidgetConnectedDevices>();

  protected deviceEntries = computed(() =>
    this.config().deviceIds.map(id => {
      const data = this.store.deviceDetails(id)();

      return {
        data,
        id,
        spaceConfig: data ? {
          floorId: data.spacePath?.find(s => s.type === SpaceType.FLOOR)?.id,
          locationId: data.location.id,
          roomId: data.spacePath?.find(s => s.type === SpaceType.ROOM)?.id,
        } : null,
      };
    }),
  );

  private statusWidgets = viewChildren(DeviceConnectionStatusWidgetComponent);
  private store = inject(DashboardStore);

  constructor() {
    effect(() => {
      this.config().deviceIds.forEach(id => this.store.loadDeviceDetails(id));
    });
  }

  protected hideTooltips() {
    this.statusWidgets().forEach(widget => widget.hideTooltips());
  }
}
